var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"substationBox"},[_c('a-icon',{attrs:{"type":"link"}}),_c('span',{staticStyle:{"line-height":"65px","padding-left":"5px"}},[_vm._v("站群分站导航")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }